// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.settings-container {
  width: 100%;
  margin: 0 auto;
  padding: 20px;
}

.settings-header {
  margin-bottom: 32px;
  padding-bottom: 20px;
  border-bottom: 2px solid var(--border-color);
}

.settings-header h1 {
  margin: 0 0 8px 0;
  font-size: 2rem;
  color: var(--text-primary);
}

.settings-subtitle {
  margin: 0;
  color: var(--text-secondary);
  font-size: 1rem;
}

.settings-content {
  margin-bottom: 80px;
}

.settings-tabs {
  display: flex;
  gap: 12px;
  margin-bottom: 20px;
  overflow-x: auto;
  white-space: nowrap;
  padding-bottom: 6px;
  -webkit-overflow-scrolling: touch;
}

.settings-tabs::-webkit-scrollbar {
  height: 4px;
}

.settings-tabs::-webkit-scrollbar-thumb {
  background: var(--border-color);
  border-radius: 4px;
}

.settings-tabs .tab {
  white-space: nowrap;
  flex-shrink: 0;
  padding: 8px 16px;
  border: 1px solid var(--border-color);
  border-radius: 6px;
  background: var(--bg-secondary);
  cursor: pointer;
  font-weight: 600;
  color:var(--text-primary)
}

.settings-tabs .tab.active {
  background: var(--bg-tertiary);
  border-color: var(--accent-primary);
}

.notifications-settings-section .settings-section {
  margin-bottom: 18px;
}

.notif-settings-filter-actions {
  display: flex;
  align-items: center;
  gap: 12px;
  margin: 10px 0 14px;
}

.notif-settings-filter-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 8px;
}

.notif-filter-item {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 0.9rem;
  color: var(--text-primary);
  border: 1px solid var(--border-color);
  border-radius: 8px;
  padding: 8px 10px;
}

.notifications-beta {
  border: 1px dashed var(--accent-primary);
  border-radius: 10px;
  padding: 12px;
}

.notifications-beta-advanced {
  margin-top: 12px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.notiflexions-list-picker {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 12px;
}

.notiflexions-list-item-group {
  display: flex;
  flex-direction: column;
  gap: 4px;
  background: var(--bg-secondary, rgba(255, 255, 255, 0.03));
  padding: 8px 12px;
  border-radius: 6px;
  border: 1px solid var(--border-color, rgba(255, 255, 255, 0.08));
}

.notiflexions-list-suboptions {
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-left: 24px;
  margin-top: 4px;
}

.notiflexions-list-suboption-toggle,
.notiflexions-list-comments-toggle {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 0.84rem;
  color: var(--text-secondary);
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}

.notiflexions-list-suboption-toggle input[type="checkbox"],
.notiflexions-list-comments-toggle input[type="checkbox"] {
  cursor: pointer;
  accent-color: var(--accent-primary);
}

/* ── Profile Settings ─────────────────────────────────── */

.profile-section {
  max-width: 600px;
}

.profile-settings-form {
  display: flex;
  flex-direction: column;
  gap: 18px;
  margin-top: 16px;
}

.profile-field {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.profile-field label {
  font-size: 0.82rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: var(--text-secondary);
}

.profile-field input,
.profile-field textarea {
  padding: 8px 12px;
  border: 1px solid var(--input-border);
  border-radius: 6px;
  background: var(--input-bg);
  color: var(--text-primary);
  font-size: 0.95rem;
  font-family: inherit;
  transition: border-color 0.2s, box-shadow 0.2s;
}

.profile-field input:focus,
.profile-field textarea:focus {
  outline: none;
  border-color: var(--accent-primary);
  box-shadow: 0 0 0 3px var(--shadow-color);
}

.profile-field textarea {
  min-height: 80px;
  resize: vertical;
}

.settings-image-preview-grid {
  margin-top: 8px;
}

.settings-image-thumb-btn {
  width: 120px;
  height: 120px;
  border: 1px solid var(--border-color);
  border-radius: 10px;
  overflow: hidden;
  background: var(--bg-secondary);
  padding: 0;
  cursor: pointer;
  display: block;
  transition: border-color 0.15s, box-shadow 0.15s;
}

.settings-image-thumb-btn--wide {
  width: 100%;
  height: 120px;
}

.settings-image-thumb-btn img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.settings-image-thumb-btn:hover {
  border-color: var(--accent-primary);
  box-shadow: 0 0 0 2px var(--accent-primary);
}

.profile-advanced-section {
  border-top: 1px solid var(--border-color);
  padding-top: 12px;
  margin-top: 4px;
}

.profile-advanced-toggle {
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 0.82rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: var(--text-secondary);
  -webkit-user-select: none;
          user-select: none;
}

.profile-advanced-toggle:hover {
  color: var(--text-primary);
}

.profile-advanced-chevron {
  display: inline-block;
  transition: transform 0.2s ease;
  font-size: 1rem;
  line-height: 1;
}

.profile-advanced-chevron.open {
  transform: rotate(180deg);
}

.profile-scope-section {
  padding-top: 12px;
  margin-top: 8px;
}

.profile-scope-title {
  font-size: 0.82rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: var(--text-secondary);
  margin: 0 0 12px 0;
}

.scope-options {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.scope-option {
  display: flex;
  align-items: center;
  gap: 8px;
}

.scope-option-body {
  flex: 1 1;
  display: flex;
  flex-direction: column;
}

.scope-option label {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  font-weight: 600;
  color: var(--text-primary);
  font-size: 0.95rem;
  -webkit-user-select: none;
          user-select: none;
}

.scope-option label input[type="checkbox"] {
  width: 16px;
  height: 16px;
  cursor: pointer;
  accent-color: var(--accent-primary);
  flex-shrink: 0;
}

.scope-option.locked label {
  cursor: default;
  color: var(--text-secondary);
}

.scope-option.locked label input[type="checkbox"] {
  cursor: default;
  opacity: 1;
  accent-color: var(--accent-primary);
}

.scope-option.unavailable label {
  cursor: not-allowed;
  color: var(--text-secondary);
  opacity: 0.55;
}

.scope-option.unavailable label input[type="checkbox"] {
  cursor: not-allowed;
}

.scope-note {
  font-size: 0.82rem;
  color: var(--text-secondary);
  margin-left: 24px;
  margin-top: 2px;
}

.scope-note code {
  font-family: monospace;
  font-size: 0.8rem;
  background: var(--bg-tertiary);
  padding: 1px 4px;
  border-radius: 3px;
}

.profile-save-row {
  display: flex;
  align-items: center;
  gap: 14px;
  padding-top: 4px;
  flex-wrap: wrap;
}

.profile-save-btn {
  padding: 10px 24px;
  background: var(--accent-primary);
  color: #fff;
  border: none;
  border-radius: 6px;
  font-size: 0.95rem;
  font-weight: 600;
  cursor: pointer;
  transition: opacity 0.2s;
}

.profile-save-btn:hover:not(:disabled) {
  opacity: 0.88;
}

.profile-save-btn:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.profile-save-status {
  font-size: 0.88rem;
  padding: 6px 10px;
  border-radius: 4px;
  font-weight: 500;
}

.profile-save-status.success {
  color: #2e7d32;
  background: color-mix(in srgb, #2e7d32 12%, var(--bg-secondary));
}

.profile-save-status.error {
  color: #c62828;
  background: color-mix(in srgb, #c62828 12%, var(--bg-secondary));
}

.scope-info-btn {
  background: none;
    border: none;
    cursor: pointer;
    color: var(--text-secondary);
    font-size: 0.9rem;
    line-height: 1;
    padding: 8px 14px 11px;
    opacity: 0.7;
    transition: opacity 0.15s, color 0.15s;
    flex-shrink: 0;
    margin-left: auto;
    border: 1px solid;
    border-radius: 10px;
}

.scope-info-btn:hover {
  opacity: 1;
  color: var(--accent-primary);
}

.settings-modal-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1200;
  padding: 20px;
}

.settings-info-modal {
  background: var(--card-bg);
  border-radius: 10px;
  width: 100%;
  max-width: 420px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.28);
  overflow: hidden;
}

.settings-info-modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 20px;
  border-bottom: 1px solid var(--border-color);
}

.settings-info-modal-header h3 {
  margin: 0;
  font-size: 1rem;
  font-weight: 600;
  color: var(--text-primary);
}

.settings-info-modal-close {
  background: none;
  border: none;
  font-size: 22px;
  line-height: 1;
  cursor: pointer;
  color: var(--text-secondary);
  padding: 0 2px;
  transition: color 0.15s;
}

.settings-info-modal-close:hover {
  color: var(--text-primary);
}

.settings-info-modal-body {
  padding: 16px 20px 20px;
}

.settings-info-modal-body p {
  margin: 0;
  font-size: 0.9rem;
  color: var(--text-secondary);
  line-height: 1.55;
}

/* ── Muted users ─────────────────────────────────────── */

.muted-section .muted-form {
  display: flex;
  gap: 8px;
  margin-bottom: 12px;
}

.muted-section .muted-form input {
  flex: 1 1;
  padding: 6px 8px;
  border: 1px solid var(--border-color);
  border-radius: 4px;
  background: var(--input-bg);
  color: var(--text-primary);
}

.muted-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.muted-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 4px 0;
  border-bottom: 1px solid var(--border-color);
}

.settings-section {
  margin-bottom: 40px;
}

.section-title {
  font-size: 1.3rem;
  margin: 0 0 8px 0;
  color: var(--text-primary);
}

.section-subtitle {
  font-size: 1.05rem;
  margin: 0 0 26px 0;
  color: var(--text-primary);
}

.section-description {
  margin: 0 0 2px 0;
  color: var(--text-secondary);
  font-size: 0.95rem;
}

.flux-sort {
  display: flex;
  gap: 16px;
  align-items: center;
}

.signature-textarea {
  width: 100%;
  margin-top: 12px;
  padding: 12px 14px;
  border: 1px solid var(--input-border);
  border-radius: 10px;
  background: var(--input-bg);
  color: var(--text-primary);
  font: inherit;
  font-size: 0.95rem;
  line-height: 1.45;
  resize: vertical;
  min-height: 88px;
  transition: border-color 0.2s ease, box-shadow 0.2s ease, background-color 0.2s ease;
}

.signature-textarea::placeholder {
  color: var(--text-secondary);
  opacity: 0.9;
}

.signature-textarea:hover {
  border-color: var(--accent-primary);
}

.signature-textarea:focus {
  outline: none;
  border-color: var(--accent-primary);
  box-shadow: 0 0 0 3px var(--shadow-color);
}

.signature-live-preview {
  margin: 12px 15%;
  border: 1px solid var(--border-color);
  border-radius: 12px;
  background: var(--bg-tertiary);
  overflow: hidden;
}

.signature-live-preview-header {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 12px;
  border-bottom: 1px solid var(--border-color);
  border-left: 0;
  border-right: 0;
  border-top: 0;
  font-size: 0.86rem;
  font-weight: 700;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  color: var(--text-secondary);
  background: var(--bg-tertiary);
  cursor: pointer;
}

.signature-live-preview-header:hover {
  color: var(--text-primary);
}

.signature-live-preview-header:focus-visible {
  outline: 2px solid var(--accent-primary);
  outline-offset: -2px;
}

.signature-preview-post-card {
  background: var(--bg-secondary);
  border-top: 1px solid var(--border-color);
  padding: 14px;
}

.signature-preview-post-header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 10px;
}

.signature-preview-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  object-fit: cover;
  flex-shrink: 0;
}

.signature-preview-author-block {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.signature-preview-author {
  font-weight: 600;
  color: var(--text-primary);
  line-height: 1.1;
}

.signature-preview-time {
  font-size: 0.82rem;
  color: var(--text-secondary);
}

.signature-preview-post-body {
  color: var(--text-primary);
  margin: 15px 0;
}

.signature-preview-context-text {
  margin: 0 0 8px;
  color: var(--text-primary);
  font-size: 0.95rem;
}

.signature-preview-divider {
  border-top: 1px solid var(--border-color);
  margin: 30px 0;
}

.signature-live-preview-content {
  padding: 0;
}

.signature-live-preview-content p:last-child {
  margin-bottom: 0;
}

.signature-live-preview-empty {
  margin: 0;
  padding: 12px;
  color: var(--text-secondary);
  font-size: 0.92rem;
  font-style: italic;
}

/* Layout Grid */
.layout-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 16px;
  margin-bottom: 20px;
}

.layout-card {
  background: var(--bg-secondary);
  border: 2px solid var(--border-color);
  border-radius: 12px;
  padding: 16px;
  cursor: pointer;
  transition: all 0.2s ease;
  text-align: center;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
}

.layout-card:hover {
  border-color: var(--accent-primary);
  box-shadow: 0 4px 12px var(--shadow-color);
}

.layout-card.active {
  border-color: var(--accent-primary);
  background: var(--bg-tertiary);
  box-shadow: 0 4px 12px var(--shadow-color);
}

.layout-preview, .mc-preview {
  width: 100%;
  height: 100px;
  background: var(--bg-primary);
  border: 1px solid var(--border-color);
  border-radius: 6px;
  display: flex;
  overflow: hidden;
}

.sidebar-preview {
  gap: 4px;
  padding: 4px;
}

.preview-sidebar {
  width: 20%;
  background: var(--bg-tertiary);
  border-radius: 2px;
}

.preview-sidebar.right {
  order: 3;
}

.preview-content {
  flex: 1 1;
  background: var(--bg-secondary);
  border-radius: 2px;
  order: 2;
}

.header-preview {
  flex-direction: column;
  gap: 4px;
  padding: 4px;
}

.preview-header {
  width: 100%;
  height: 25%;
  background: var(--bg-tertiary);
  border-radius: 2px;
}

.layout-label {
  font-size: 0.95rem;
  font-weight: 600;
  color: var(--text-primary);
}

.layout-preference {
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.layout-preference-label {
  margin: 0;
  font-size: 0.95rem;
  color: var(--text-secondary);
}

.flux-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 16px;
}

.flux-preview {
  width: 100%;
  height: 100px;
  background: var(--bg-primary);
  border: 1px solid var(--border-color);
  border-radius: 6px;
  display: grid;
  gap: 6px;
  padding: 8px;
}

.flux-preview.grid-preview {
  grid-template-columns: repeat(3, 1fr);
  grid-auto-rows: 1fr;
}

.flux-preview.list-preview {
  grid-template-columns: 1fr;
  grid-auto-rows: 1fr;
}

.flux-tile,
.flux-row {
  background: var(--bg-secondary);
  border-radius: 4px;
  color:var(--text-primary);
  display: flex;
}

.flux-row {
  position: relative;
}

.flux-row div {
  position: absolute;
  bottom:0;
  right:0;
  width:95%;
  height: 60%;
  border-left: 1px solid var(--accent-primary);
  float:right;
  vertical-align: baseline;
}

/* Comment display preview */
.comment-preview-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 16px;
}

.comment-display-preview-section .layout-card {
  align-items: flex-start;
  text-align: left;
}

.comment-display-preview-section .layout-label {
  margin-top: 4px;
}

.comment-display-preview-section .option-desc, .settings-section .option-desc {
  font-size: 0.85rem;
  color: var(--text-secondary);
  line-height: 1.35;
}

.flux-preview.preview-small {
  height: 64px;
  padding: 6px;
  gap: 4px;
}

/* Comment display previews */

.comment-preview {
  width: 100%;
  min-height: 120px;
  background: var(--bg-primary);
  border: 1px solid var(--border-color);
  border-radius: 8px;
  padding: 10px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.preview-card {
  background: var(--bg-secondary);
  border: 1px solid var(--border-color);
  border-radius: 8px;
  padding: 8px;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.preview-card-header {
  display: flex;
  align-items: center;
  gap: 6px;
}

.preview-avatar {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: var(--bg-tertiary);
}

.preview-avatar.small {
  width: 12px;
  height: 12px;
}

.preview-card-body {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.preview-line {
  height: 6px;
  border-radius: 4px;
  background: var(--text-tertiary);
}

.preview-line.short {
  width: 60%;
}

.preview-line.tiny {
  width: 30%;
  height: 4px;
}

.preview-card-actions {
  display: flex;
  gap: 6px;
}

.preview-card-actions span {
  width: 14px;
  height: 5px;
  border-radius: 999px;
  background: var(--bg-tertiary);
}

.preview-thread {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.preview-comment.level-1 {
  margin-left: 6px;
}

.preview-comment.level-2 {
  margin-left: 16px;
}

.preview-inline-thread {
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding-left: 4px;
  border-left: 1px solid var(--accent-primary);
  border-radius: 6px;
  vertical-align: baseline;
  justify-content: flex-end;
  height:40px;
}

.preview-inline-row {
  display: flex;
  align-items: center;
  gap: 6px;
}

.preview-inline-row.nested {
  padding-left: 12px;
  border-left: 1px solid var(--accent-primary);
  border-radius: 6px;
  height:16px;
}

.preview-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: var(--bg-tertiary);
}

.preview-pill {
  width: 12px;
  height: 4px;
  border-radius: 999px;
  background: var(--bg-tertiary);
}

.comment-preview-header {
  display: flex;
  gap: 8px;
  align-items: center;
}

.comment-preview-avatar {
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background: var(--bg-tertiary);
}

.comment-preview-lines {
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1 1;
}

.comment-preview-line {
  height: 6px;
  border-radius: 4px;
  background: var(--bg-secondary);
}

.comment-preview-line.short {
  width: 60%;
}

.comment-preview-body {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.comment-preview-actions {
  display: flex;
  gap: 8px;
}

.comment-preview-actions span {
  width: 16px;
  height: 6px;
  border-radius: 999px;
  background: var(--bg-tertiary);
}

.comment-preview-row {
  display: flex;
  align-items: center;
  gap: 8px;
}


/* Theme Grid */
.theme-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 16px;
}

.theme-card {
  background: var(--bg-secondary);
  border: 2px solid var(--border-color);
  border-radius: 12px;
  padding: 16px;
  cursor: pointer;
  transition: all 0.2s ease;
  text-align: left;
  display: flex;
  flex-direction: column;
}

.theme-card:hover {
  border-color: var(--accent-primary);
  box-shadow: 0 4px 12px var(--shadow-color);
}

.theme-card.active {
  border-color: var(--accent-primary);
  background: var(--bg-tertiary);
  box-shadow: 0 4px 12px var(--shadow-color);
}

.theme-content {
  display: flex;
  gap: 12px;
  align-items: center;
}

.theme-text {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.theme-content .color-preview {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  border: 1px solid var(--border-color);
  transition: all 0.2s ease;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

.theme-content .checkmark {
  font-size: 1.1rem;
  font-weight: bold;
  color: var(--accent-primary);
  text-shadow: 0 0 8px rgba(0, 0, 0, 0.3);
}

.theme-card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}

.theme-label {
  font-size: 1.1rem;
  font-weight: 600;
  color: var(--text-primary);
}

.theme-description {
  margin: 0;
  font-size: 0.9rem;
  color: var(--text-secondary);
}

.active-indicator {
  color: var(--accent-primary);
  font-size: 1.2rem;
  font-weight: bold;
}

/* Accent Color Grid */
.accent-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));
  gap: 16px;
}

.accent-card {
  background: var(--bg-secondary);
  border: 2px solid var(--border-color);
  border-radius: 12px;
  padding: 16px;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  position: relative;
}

.accent-card:hover {
  border-color: var(--accent-primary);
  box-shadow: 0 4px 12px var(--shadow-color);
}

.accent-card.active {
  border-color: var(--accent-primary);
  background: var(--bg-tertiary);
  box-shadow: 0 4px 12px var(--shadow-color);
}

.color-preview {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  border: 3px solid var(--border-color);
}

.accent-label {
  font-size: 0.95rem;
  font-weight: 600;
  color: var(--text-primary);
}

.accent-card .active-indicator {
  position: absolute;
  top: 8px;
  right: 8px;
}

input[type="range"] {
  width: 100%;
}

.reward-currency-setting {
  margin-top: 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.reward-currency-label {
  font-size: 0.95rem; 
}

.currency-toggle {
  position: relative;
  display: flex;
  align-items: center;
  width: 160px;
  padding: 4px;
  border-radius: 999px;
  border: 1px solid var(--input-border);
  background: var(--bg-secondary);
}

.currency-toggle .currency-option {
  flex: 1 1;
  text-align: center;
  margin-top: -2px;
  padding:4px;
  font-size: 0.85rem;
  font-weight: 600;
  color: var(--text-secondary);
  z-index: 1;
}

.currency-toggle .currency-option.active {
  color: var(--accent-primary);
}

.currency-toggle .currency-slider {
  position: absolute;
  top: 4px;
  bottom: 4px;
  left: 4px;
  width: calc(50% - 4px);
  background: var(--bg-primary);
  border-radius: 999px;
  box-shadow: 0 2px 8px var(--shadow-color);
  transition: transform 0.2s ease;
}

.currency-toggle.right .currency-slider {
  transform: translateX(100%);
}

/* Preview Info */
.preview-info {
  background: var(--bg-tertiary);
  border: 1px solid var(--border-color);
  border-radius: 12px;
  padding: 16px;
  display: flex;
  gap: 16px;
  align-items: flex-start;
}

.preview-icon {
  font-size: 1.5rem;
}

.preview-text {
  flex: 1 1;
}

.preview-text strong {
  display: block;
  margin-bottom: 4px;
  color: var(--text-primary);
  font-size: 1rem;
}

.preview-text p, .coming-soon {
  margin: 0;
  color: var(--text-secondary);
  font-size: 0.9rem;
}
.disabled {
  pointer-events: none;
  opacity: 0.6;
  border: 2px solid var(--border-color);
}
.disabled:hover {
  pointer-events: none;
  opacity: 0.6;
  border: 2px solid var(--border-color);
}

/* Current Selection */
.current-selection {
  background: var(--bg-secondary);
  border: 1px solid var(--border-color);
  border-radius: 12px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.selection-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.selection-label {
  color: var(--text-secondary);
  font-size: 0.95rem;
}

.selection-value {
  color: var(--text-primary);
  font-weight: 600;
  font-size: 1rem;
}

/* Footer */
.settings-footer {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: var(--bg-secondary);
  border-top: 2px solid var(--border-color);
  padding: 16px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0 -4px 12px var(--shadow-color);
  z-index: 100;
}

.unsaved-indicator {
  display: flex;
  align-items: center;
  gap: 8px;
  color: var(--accent-primary);
  font-weight: 500;
}

.unsaved-dot {
  animation: pulse 2s infinite;
}

@keyframes pulse {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.5; }
}

.footer-buttons {
  display: flex;
  gap: 12px;
}

.reset-btn {
  padding: 12px 24px;
  background: var(--bg-tertiary);
  color: var(--text-primary);
  border: 1px solid var(--border-color);
  border-radius: 8px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}

.reset-btn:hover {
  background: var(--bg-primary);
  border-color: var(--error-color);
  color: var(--error-color);
}

.save-btn {
  padding: 12px 32px;
  background: var(--accent-primary);
  color: white;
  border: none;
  border-radius: 8px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: 1rem;
}

.save-btn:hover:not(:disabled) {
  background: var(--accent-hover);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}

.save-btn:disabled {
  background: var(--bg-tertiary);
  color: var(--text-tertiary);
  cursor: not-allowed;
  opacity: 0.6;
}

.save-btn.has-changes {
  animation: glow 2s infinite;
}

@keyframes glow {
  0%, 100% { box-shadow: 0 0 8px var(--accent-primary); }
  50% { box-shadow: 0 0 16px var(--accent-primary); }
}

@media (max-width: 768px) {
  .settings-container {
    padding: 16px;
  }

  .signature-textarea {
    font-size: 0.92rem;
    padding: 10px 12px;
  }

  .signature-live-preview-header {
    padding: 9px 10px;
    font-size: 0.82rem;
  }

  .signature-preview-post-card {
    padding: 12px;
  }

  .signature-preview-avatar {
    width: 36px;
    height: 36px;
  }

  .signature-live-preview-content,
  .signature-live-preview-empty {
    padding: 0;
  }

  .signature-live-preview-empty {
    padding-top: 2px;
  }

  .theme-grid {
    grid-template-columns: 1fr;
  }

  .accent-grid {
    grid-template-columns: repeat(3, 1fr);
  }

  .settings-footer {
    flex-direction: column;
    gap: 12px;
  }

  .footer-buttons {
    width: 100%;
  }

  .reset-btn,
  .save-btn {
    flex: 1 1;
  }
}

/* Notification opt-in styles removed */

/* Data Sync Section */
.sync-info {
  background: var(--bg-tertiary);
  border: 1px solid var(--border-color);
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 16px;
}

.sync-info p {
  margin: 0 0 8px 0;
  color: var(--text-primary);
  font-weight: 500;
}

.sync-info ul {
  margin: 0;
  padding-left: 20px;
  color: var(--text-secondary);
}

.sync-info li {
  margin: 4px 0;
}

.sync-btn {
  padding: 14px 28px;
  background: var(--accent-primary);
  color: white;
  border: none;
  border-radius: 8px;
  font-weight: 600;
  font-size: 1rem;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  gap: 10px;
  width: fit-content;
}

.sync-btn:hover:not(:disabled) {
  background: var(--accent-hover);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  transform: translateY(-2px);
}

.sync-btn:disabled {
  background: var(--bg-tertiary);
  color: var(--text-tertiary);
  cursor: not-allowed;
  opacity: 0.6;
}

.sync-icon {
  font-size: 1.2rem;
}

.sync-spinner {
  font-size: 1.2rem;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

.sync-status {
  margin-top: 12px;
  padding: 12px 16px;
  border-radius: 8px;
  font-size: 0.95rem;
  font-weight: 500;
}

.sync-status.success {
  background: rgba(76, 175, 80, 0.1);
  color: #4caf50;
  border: 1px solid rgba(76, 175, 80, 0.3);
}

.sync-status.warning {
  background: rgba(255, 152, 0, 0.1);
  color: #ff9800;
  border: 1px solid rgba(255, 152, 0, 0.3);
}

.sync-status.error {
  background: rgba(244, 67, 54, 0.1);
  color: #f44336;
  border: 1px solid rgba(244, 67, 54, 0.3);
}
`, "",{"version":3,"sources":["webpack://./src/pages/Settings.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,cAAc;EACd,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,4CAA4C;AAC9C;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,SAAS;EACT,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,qCAAqC;EACrC,kBAAkB;EAClB,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB;AACF;;AAEA;EACE,8BAA8B;EAC9B,mCAAmC;AACrC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,0BAA0B;EAC1B,qCAAqC;EACrC,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,wCAAwC;EACxC,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,0DAA0D;EAC1D,iBAAiB;EACjB,kBAAkB;EAClB,gEAAgE;AAClE;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,iBAAiB;EACjB,eAAe;AACjB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,4BAA4B;EAC5B,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;;EAEE,eAAe;EACf,mCAAmC;AACrC;;AAEA,4DAA4D;;AAE5D;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,4BAA4B;AAC9B;;AAEA;;EAEE,iBAAiB;EACjB,qCAAqC;EACrC,kBAAkB;EAClB,2BAA2B;EAC3B,0BAA0B;EAC1B,kBAAkB;EAClB,oBAAoB;EACpB,8CAA8C;AAChD;;AAEA;;EAEE,aAAa;EACb,mCAAmC;EACnC,yCAAyC;AAC3C;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,qCAAqC;EACrC,mBAAmB;EACnB,gBAAgB;EAChB,+BAA+B;EAC/B,UAAU;EACV,eAAe;EACf,cAAc;EACd,gDAAgD;AAClD;;AAEA;EACE,WAAW;EACX,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,2CAA2C;AAC7C;;AAEA;EACE,yCAAyC;EACzC,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,4BAA4B;EAC5B,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;EACrB,+BAA+B;EAC/B,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;EAClB,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,UAAU;EACV,mCAAmC;AACrC;;AAEA;EACE,mBAAmB;EACnB,4BAA4B;EAC5B,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,iBAAiB;EACjB,8BAA8B;EAC9B,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,iCAAiC;EACjC,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gEAAgE;AAClE;;AAEA;EACE,cAAc;EACd,gEAAgE;AAClE;;AAEA;EACE,gBAAgB;IACd,YAAY;IACZ,eAAe;IACf,4BAA4B;IAC5B,iBAAiB;IACjB,cAAc;IACd,sBAAsB;IACtB,YAAY;IACZ,sCAAsC;IACtC,cAAc;IACd,iBAAiB;IACjB,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;EACE,UAAU;EACV,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,0CAA0C;EAC1C,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,4CAA4C;AAC9C;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,eAAe;EACf,4BAA4B;EAC5B,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,4BAA4B;EAC5B,iBAAiB;AACnB;;AAEA,2DAA2D;;AAE3D;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,qCAAqC;EACrC,kBAAkB;EAClB,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,cAAc;EACd,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,qCAAqC;EACrC,mBAAmB;EACnB,2BAA2B;EAC3B,0BAA0B;EAC1B,aAAa;EACb,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,oFAAoF;AACtF;;AAEA;EACE,4BAA4B;EAC5B,YAAY;AACd;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,mCAAmC;EACnC,yCAAyC;AAC3C;;AAEA;EACE,gBAAgB;EAChB,qCAAqC;EACrC,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,4CAA4C;EAC5C,cAAc;EACd,eAAe;EACf,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,4BAA4B;EAC5B,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,wCAAwC;EACxC,oBAAoB;AACtB;;AAEA;EACE,+BAA+B;EAC/B,yCAAyC;EACzC,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,yCAAyC;EACzC,cAAc;AAChB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,aAAa;EACb,4BAA4B;EAC5B,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,qCAAqC;EACrC,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,mCAAmC;EACnC,0CAA0C;AAC5C;;AAEA;EACE,mCAAmC;EACnC,8BAA8B;EAC9B,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,aAAa;EACb,6BAA6B;EAC7B,qCAAqC;EACrC,kBAAkB;EAClB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,UAAU;EACV,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,SAAO;EACP,+BAA+B;EAC/B,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EACE,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,WAAW;EACX,WAAW;EACX,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,WAAW;EACX,aAAa;EACb,6BAA6B;EAC7B,qCAAqC;EACrC,kBAAkB;EAClB,aAAa;EACb,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,qCAAqC;EACrC,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;;EAEE,+BAA+B;EAC/B,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,OAAO;EACP,SAAS;EACT,WAAW;EACX,4CAA4C;EAC5C,WAAW;EACX,wBAAwB;AAC1B;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,QAAQ;AACV;;AAEA,6BAA6B;;AAE7B;EACE,WAAW;EACX,iBAAiB;EACjB,6BAA6B;EAC7B,qCAAqC;EACrC,kBAAkB;EAClB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,+BAA+B;EAC/B,qCAAqC;EACrC,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,WAAW;EACX,oBAAoB;EACpB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,iBAAiB;EACjB,4CAA4C;EAC5C,kBAAkB;EAClB,wBAAwB;EACxB,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,4CAA4C;EAC5C,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,WAAW;EACX,oBAAoB;EACpB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,SAAO;AACT;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,WAAW;EACX,oBAAoB;EACpB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;;AAGA,eAAe;AACf;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,+BAA+B;EAC/B,qCAAqC;EACrC,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,mCAAmC;EACnC,0CAA0C;AAC5C;;AAEA;EACE,mCAAmC;EACnC,8BAA8B;EAC9B,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qCAAqC;EACrC,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,4BAA4B;EAC5B,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;EAC5B,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,+BAA+B;EAC/B,qCAAqC;EACrC,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,mCAAmC;EACnC,0CAA0C;AAC5C;;AAEA;EACE,mCAAmC;EACnC,8BAA8B;EAC9B,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,oBAAoB;EACpB,qCAAqC;EACrC,+BAA+B;AACjC;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;EAC5B,UAAU;AACZ;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,SAAS;EACT,sBAAsB;EACtB,6BAA6B;EAC7B,oBAAoB;EACpB,yCAAyC;EACzC,+BAA+B;AACjC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,iBAAiB;AACjB;EACE,8BAA8B;EAC9B,qCAAqC;EACrC,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,4BAA4B;EAC5B,iBAAiB;AACnB;AACA;EACE,oBAAoB;EACpB,YAAY;EACZ,qCAAqC;AACvC;AACA;EACE,oBAAoB;EACpB,YAAY;EACZ,qCAAqC;AACvC;;AAEA,sBAAsB;AACtB;EACE,+BAA+B;EAC/B,qCAAqC;EACrC,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,eAAe;AACjB;;AAEA,WAAW;AACX;EACE,eAAe;EACf,SAAS;EACT,OAAO;EACP,QAAQ;EACR,+BAA+B;EAC/B,yCAAyC;EACzC,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,2CAA2C;EAC3C,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,WAAW,UAAU,EAAE;EACvB,MAAM,YAAY,EAAE;AACtB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,8BAA8B;EAC9B,0BAA0B;EAC1B,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;EAC7B,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,iCAAiC;EACjC,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,+BAA+B;EAC/B,yCAAyC;AAC3C;;AAEA;EACE,8BAA8B;EAC9B,2BAA2B;EAC3B,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,WAAW,yCAAyC,EAAE;EACtD,MAAM,0CAA0C,EAAE;AACpD;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;;IAEE,UAAU;EACZ;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,WAAW;EACb;;EAEA;;IAEE,SAAO;EACT;AACF;;AAEA,uCAAuC;;AAEvC,sBAAsB;AACtB;EACE,8BAA8B;EAC9B,qCAAqC;EACrC,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,iCAAiC;EACjC,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;EAC/B,yCAAyC;EACzC,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;EAC9B,2BAA2B;EAC3B,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,kCAAkC;AACpC;;AAEA;EACE,OAAO,uBAAuB,EAAE;EAChC,KAAK,yBAAyB,EAAE;AAClC;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,cAAc;EACd,wCAAwC;AAC1C;;AAEA;EACE,kCAAkC;EAClC,cAAc;EACd,wCAAwC;AAC1C;;AAEA;EACE,kCAAkC;EAClC,cAAc;EACd,wCAAwC;AAC1C","sourcesContent":[".settings-container {\r\n  width: 100%;\r\n  margin: 0 auto;\r\n  padding: 20px;\r\n}\r\n\r\n.settings-header {\r\n  margin-bottom: 32px;\r\n  padding-bottom: 20px;\r\n  border-bottom: 2px solid var(--border-color);\r\n}\r\n\r\n.settings-header h1 {\r\n  margin: 0 0 8px 0;\r\n  font-size: 2rem;\r\n  color: var(--text-primary);\r\n}\r\n\r\n.settings-subtitle {\r\n  margin: 0;\r\n  color: var(--text-secondary);\r\n  font-size: 1rem;\r\n}\r\n\r\n.settings-content {\r\n  margin-bottom: 80px;\r\n}\r\n\r\n.settings-tabs {\r\n  display: flex;\r\n  gap: 12px;\r\n  margin-bottom: 20px;\r\n  overflow-x: auto;\r\n  white-space: nowrap;\r\n  padding-bottom: 6px;\r\n  -webkit-overflow-scrolling: touch;\r\n}\r\n\r\n.settings-tabs::-webkit-scrollbar {\r\n  height: 4px;\r\n}\r\n\r\n.settings-tabs::-webkit-scrollbar-thumb {\r\n  background: var(--border-color);\r\n  border-radius: 4px;\r\n}\r\n\r\n.settings-tabs .tab {\r\n  white-space: nowrap;\r\n  flex-shrink: 0;\r\n  padding: 8px 16px;\r\n  border: 1px solid var(--border-color);\r\n  border-radius: 6px;\r\n  background: var(--bg-secondary);\r\n  cursor: pointer;\r\n  font-weight: 600;\r\n  color:var(--text-primary)\r\n}\r\n\r\n.settings-tabs .tab.active {\r\n  background: var(--bg-tertiary);\r\n  border-color: var(--accent-primary);\r\n}\r\n\r\n.notifications-settings-section .settings-section {\r\n  margin-bottom: 18px;\r\n}\r\n\r\n.notif-settings-filter-actions {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 12px;\r\n  margin: 10px 0 14px;\r\n}\r\n\r\n.notif-settings-filter-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\r\n  gap: 8px;\r\n}\r\n\r\n.notif-filter-item {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  font-size: 0.9rem;\r\n  color: var(--text-primary);\r\n  border: 1px solid var(--border-color);\r\n  border-radius: 8px;\r\n  padding: 8px 10px;\r\n}\r\n\r\n.notifications-beta {\r\n  border: 1px dashed var(--accent-primary);\r\n  border-radius: 10px;\r\n  padding: 12px;\r\n}\r\n\r\n.notifications-beta-advanced {\r\n  margin-top: 12px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 10px;\r\n}\r\n\r\n.notiflexions-list-picker {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));\r\n  gap: 12px;\r\n}\r\n\r\n.notiflexions-list-item-group {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 4px;\r\n  background: var(--bg-secondary, rgba(255, 255, 255, 0.03));\r\n  padding: 8px 12px;\r\n  border-radius: 6px;\r\n  border: 1px solid var(--border-color, rgba(255, 255, 255, 0.08));\r\n}\r\n\r\n.notiflexions-list-suboptions {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 6px;\r\n  margin-left: 24px;\r\n  margin-top: 4px;\r\n}\r\n\r\n.notiflexions-list-suboption-toggle,\r\n.notiflexions-list-comments-toggle {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  font-size: 0.84rem;\r\n  color: var(--text-secondary);\r\n  cursor: pointer;\r\n  user-select: none;\r\n}\r\n\r\n.notiflexions-list-suboption-toggle input[type=\"checkbox\"],\r\n.notiflexions-list-comments-toggle input[type=\"checkbox\"] {\r\n  cursor: pointer;\r\n  accent-color: var(--accent-primary);\r\n}\r\n\r\n/* ── Profile Settings ─────────────────────────────────── */\r\n\r\n.profile-section {\r\n  max-width: 600px;\r\n}\r\n\r\n.profile-settings-form {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 18px;\r\n  margin-top: 16px;\r\n}\r\n\r\n.profile-field {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 4px;\r\n}\r\n\r\n.profile-field label {\r\n  font-size: 0.82rem;\r\n  font-weight: 600;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.05em;\r\n  color: var(--text-secondary);\r\n}\r\n\r\n.profile-field input,\r\n.profile-field textarea {\r\n  padding: 8px 12px;\r\n  border: 1px solid var(--input-border);\r\n  border-radius: 6px;\r\n  background: var(--input-bg);\r\n  color: var(--text-primary);\r\n  font-size: 0.95rem;\r\n  font-family: inherit;\r\n  transition: border-color 0.2s, box-shadow 0.2s;\r\n}\r\n\r\n.profile-field input:focus,\r\n.profile-field textarea:focus {\r\n  outline: none;\r\n  border-color: var(--accent-primary);\r\n  box-shadow: 0 0 0 3px var(--shadow-color);\r\n}\r\n\r\n.profile-field textarea {\r\n  min-height: 80px;\r\n  resize: vertical;\r\n}\r\n\r\n.settings-image-preview-grid {\r\n  margin-top: 8px;\r\n}\r\n\r\n.settings-image-thumb-btn {\r\n  width: 120px;\r\n  height: 120px;\r\n  border: 1px solid var(--border-color);\r\n  border-radius: 10px;\r\n  overflow: hidden;\r\n  background: var(--bg-secondary);\r\n  padding: 0;\r\n  cursor: pointer;\r\n  display: block;\r\n  transition: border-color 0.15s, box-shadow 0.15s;\r\n}\r\n\r\n.settings-image-thumb-btn--wide {\r\n  width: 100%;\r\n  height: 120px;\r\n}\r\n\r\n.settings-image-thumb-btn img {\r\n  width: 100%;\r\n  height: 100%;\r\n  object-fit: cover;\r\n  display: block;\r\n}\r\n\r\n.settings-image-thumb-btn:hover {\r\n  border-color: var(--accent-primary);\r\n  box-shadow: 0 0 0 2px var(--accent-primary);\r\n}\r\n\r\n.profile-advanced-section {\r\n  border-top: 1px solid var(--border-color);\r\n  padding-top: 12px;\r\n  margin-top: 4px;\r\n}\r\n\r\n.profile-advanced-toggle {\r\n  background: none;\r\n  border: none;\r\n  padding: 0;\r\n  cursor: pointer;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  font-size: 0.82rem;\r\n  font-weight: 600;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.05em;\r\n  color: var(--text-secondary);\r\n  user-select: none;\r\n}\r\n\r\n.profile-advanced-toggle:hover {\r\n  color: var(--text-primary);\r\n}\r\n\r\n.profile-advanced-chevron {\r\n  display: inline-block;\r\n  transition: transform 0.2s ease;\r\n  font-size: 1rem;\r\n  line-height: 1;\r\n}\r\n\r\n.profile-advanced-chevron.open {\r\n  transform: rotate(180deg);\r\n}\r\n\r\n.profile-scope-section {\r\n  padding-top: 12px;\r\n  margin-top: 8px;\r\n}\r\n\r\n.profile-scope-title {\r\n  font-size: 0.82rem;\r\n  font-weight: 600;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.05em;\r\n  color: var(--text-secondary);\r\n  margin: 0 0 12px 0;\r\n}\r\n\r\n.scope-options {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 12px;\r\n}\r\n\r\n.scope-option {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n}\r\n\r\n.scope-option-body {\r\n  flex: 1;\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.scope-option label {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  cursor: pointer;\r\n  font-weight: 600;\r\n  color: var(--text-primary);\r\n  font-size: 0.95rem;\r\n  user-select: none;\r\n}\r\n\r\n.scope-option label input[type=\"checkbox\"] {\r\n  width: 16px;\r\n  height: 16px;\r\n  cursor: pointer;\r\n  accent-color: var(--accent-primary);\r\n  flex-shrink: 0;\r\n}\r\n\r\n.scope-option.locked label {\r\n  cursor: default;\r\n  color: var(--text-secondary);\r\n}\r\n\r\n.scope-option.locked label input[type=\"checkbox\"] {\r\n  cursor: default;\r\n  opacity: 1;\r\n  accent-color: var(--accent-primary);\r\n}\r\n\r\n.scope-option.unavailable label {\r\n  cursor: not-allowed;\r\n  color: var(--text-secondary);\r\n  opacity: 0.55;\r\n}\r\n\r\n.scope-option.unavailable label input[type=\"checkbox\"] {\r\n  cursor: not-allowed;\r\n}\r\n\r\n.scope-note {\r\n  font-size: 0.82rem;\r\n  color: var(--text-secondary);\r\n  margin-left: 24px;\r\n  margin-top: 2px;\r\n}\r\n\r\n.scope-note code {\r\n  font-family: monospace;\r\n  font-size: 0.8rem;\r\n  background: var(--bg-tertiary);\r\n  padding: 1px 4px;\r\n  border-radius: 3px;\r\n}\r\n\r\n.profile-save-row {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 14px;\r\n  padding-top: 4px;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.profile-save-btn {\r\n  padding: 10px 24px;\r\n  background: var(--accent-primary);\r\n  color: #fff;\r\n  border: none;\r\n  border-radius: 6px;\r\n  font-size: 0.95rem;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  transition: opacity 0.2s;\r\n}\r\n\r\n.profile-save-btn:hover:not(:disabled) {\r\n  opacity: 0.88;\r\n}\r\n\r\n.profile-save-btn:disabled {\r\n  opacity: 0.55;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.profile-save-status {\r\n  font-size: 0.88rem;\r\n  padding: 6px 10px;\r\n  border-radius: 4px;\r\n  font-weight: 500;\r\n}\r\n\r\n.profile-save-status.success {\r\n  color: #2e7d32;\r\n  background: color-mix(in srgb, #2e7d32 12%, var(--bg-secondary));\r\n}\r\n\r\n.profile-save-status.error {\r\n  color: #c62828;\r\n  background: color-mix(in srgb, #c62828 12%, var(--bg-secondary));\r\n}\r\n\r\n.scope-info-btn {\r\n  background: none;\r\n    border: none;\r\n    cursor: pointer;\r\n    color: var(--text-secondary);\r\n    font-size: 0.9rem;\r\n    line-height: 1;\r\n    padding: 8px 14px 11px;\r\n    opacity: 0.7;\r\n    transition: opacity 0.15s, color 0.15s;\r\n    flex-shrink: 0;\r\n    margin-left: auto;\r\n    border: 1px solid;\r\n    border-radius: 10px;\r\n}\r\n\r\n.scope-info-btn:hover {\r\n  opacity: 1;\r\n  color: var(--accent-primary);\r\n}\r\n\r\n.settings-modal-backdrop {\r\n  position: fixed;\r\n  inset: 0;\r\n  background: rgba(0, 0, 0, 0.5);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  z-index: 1200;\r\n  padding: 20px;\r\n}\r\n\r\n.settings-info-modal {\r\n  background: var(--card-bg);\r\n  border-radius: 10px;\r\n  width: 100%;\r\n  max-width: 420px;\r\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.28);\r\n  overflow: hidden;\r\n}\r\n\r\n.settings-info-modal-header {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  padding: 14px 20px;\r\n  border-bottom: 1px solid var(--border-color);\r\n}\r\n\r\n.settings-info-modal-header h3 {\r\n  margin: 0;\r\n  font-size: 1rem;\r\n  font-weight: 600;\r\n  color: var(--text-primary);\r\n}\r\n\r\n.settings-info-modal-close {\r\n  background: none;\r\n  border: none;\r\n  font-size: 22px;\r\n  line-height: 1;\r\n  cursor: pointer;\r\n  color: var(--text-secondary);\r\n  padding: 0 2px;\r\n  transition: color 0.15s;\r\n}\r\n\r\n.settings-info-modal-close:hover {\r\n  color: var(--text-primary);\r\n}\r\n\r\n.settings-info-modal-body {\r\n  padding: 16px 20px 20px;\r\n}\r\n\r\n.settings-info-modal-body p {\r\n  margin: 0;\r\n  font-size: 0.9rem;\r\n  color: var(--text-secondary);\r\n  line-height: 1.55;\r\n}\r\n\r\n/* ── Muted users ─────────────────────────────────────── */\r\n\r\n.muted-section .muted-form {\r\n  display: flex;\r\n  gap: 8px;\r\n  margin-bottom: 12px;\r\n}\r\n\r\n.muted-section .muted-form input {\r\n  flex: 1;\r\n  padding: 6px 8px;\r\n  border: 1px solid var(--border-color);\r\n  border-radius: 4px;\r\n  background: var(--input-bg);\r\n  color: var(--text-primary);\r\n}\r\n\r\n.muted-list {\r\n  list-style: none;\r\n  padding: 0;\r\n  margin: 0;\r\n}\r\n\r\n.muted-item {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  padding: 4px 0;\r\n  border-bottom: 1px solid var(--border-color);\r\n}\r\n\r\n.settings-section {\r\n  margin-bottom: 40px;\r\n}\r\n\r\n.section-title {\r\n  font-size: 1.3rem;\r\n  margin: 0 0 8px 0;\r\n  color: var(--text-primary);\r\n}\r\n\r\n.section-subtitle {\r\n  font-size: 1.05rem;\r\n  margin: 0 0 26px 0;\r\n  color: var(--text-primary);\r\n}\r\n\r\n.section-description {\r\n  margin: 0 0 2px 0;\r\n  color: var(--text-secondary);\r\n  font-size: 0.95rem;\r\n}\r\n\r\n.flux-sort {\r\n  display: flex;\r\n  gap: 16px;\r\n  align-items: center;\r\n}\r\n\r\n.signature-textarea {\r\n  width: 100%;\r\n  margin-top: 12px;\r\n  padding: 12px 14px;\r\n  border: 1px solid var(--input-border);\r\n  border-radius: 10px;\r\n  background: var(--input-bg);\r\n  color: var(--text-primary);\r\n  font: inherit;\r\n  font-size: 0.95rem;\r\n  line-height: 1.45;\r\n  resize: vertical;\r\n  min-height: 88px;\r\n  transition: border-color 0.2s ease, box-shadow 0.2s ease, background-color 0.2s ease;\r\n}\r\n\r\n.signature-textarea::placeholder {\r\n  color: var(--text-secondary);\r\n  opacity: 0.9;\r\n}\r\n\r\n.signature-textarea:hover {\r\n  border-color: var(--accent-primary);\r\n}\r\n\r\n.signature-textarea:focus {\r\n  outline: none;\r\n  border-color: var(--accent-primary);\r\n  box-shadow: 0 0 0 3px var(--shadow-color);\r\n}\r\n\r\n.signature-live-preview {\r\n  margin: 12px 15%;\r\n  border: 1px solid var(--border-color);\r\n  border-radius: 12px;\r\n  background: var(--bg-tertiary);\r\n  overflow: hidden;\r\n}\r\n\r\n.signature-live-preview-header {\r\n  width: 100%;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  padding: 10px 12px;\r\n  border-bottom: 1px solid var(--border-color);\r\n  border-left: 0;\r\n  border-right: 0;\r\n  border-top: 0;\r\n  font-size: 0.86rem;\r\n  font-weight: 700;\r\n  letter-spacing: 0.02em;\r\n  text-transform: uppercase;\r\n  color: var(--text-secondary);\r\n  background: var(--bg-tertiary);\r\n  cursor: pointer;\r\n}\r\n\r\n.signature-live-preview-header:hover {\r\n  color: var(--text-primary);\r\n}\r\n\r\n.signature-live-preview-header:focus-visible {\r\n  outline: 2px solid var(--accent-primary);\r\n  outline-offset: -2px;\r\n}\r\n\r\n.signature-preview-post-card {\r\n  background: var(--bg-secondary);\r\n  border-top: 1px solid var(--border-color);\r\n  padding: 14px;\r\n}\r\n\r\n.signature-preview-post-header {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.signature-preview-avatar {\r\n  width: 40px;\r\n  height: 40px;\r\n  border-radius: 50%;\r\n  object-fit: cover;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.signature-preview-author-block {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 2px;\r\n}\r\n\r\n.signature-preview-author {\r\n  font-weight: 600;\r\n  color: var(--text-primary);\r\n  line-height: 1.1;\r\n}\r\n\r\n.signature-preview-time {\r\n  font-size: 0.82rem;\r\n  color: var(--text-secondary);\r\n}\r\n\r\n.signature-preview-post-body {\r\n  color: var(--text-primary);\r\n  margin: 15px 0;\r\n}\r\n\r\n.signature-preview-context-text {\r\n  margin: 0 0 8px;\r\n  color: var(--text-primary);\r\n  font-size: 0.95rem;\r\n}\r\n\r\n.signature-preview-divider {\r\n  border-top: 1px solid var(--border-color);\r\n  margin: 30px 0;\r\n}\r\n\r\n.signature-live-preview-content {\r\n  padding: 0;\r\n}\r\n\r\n.signature-live-preview-content p:last-child {\r\n  margin-bottom: 0;\r\n}\r\n\r\n.signature-live-preview-empty {\r\n  margin: 0;\r\n  padding: 12px;\r\n  color: var(--text-secondary);\r\n  font-size: 0.92rem;\r\n  font-style: italic;\r\n}\r\n\r\n/* Layout Grid */\r\n.layout-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));\r\n  gap: 16px;\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.layout-card {\r\n  background: var(--bg-secondary);\r\n  border: 2px solid var(--border-color);\r\n  border-radius: 12px;\r\n  padding: 16px;\r\n  cursor: pointer;\r\n  transition: all 0.2s ease;\r\n  text-align: center;\r\n  position: relative;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  gap: 12px;\r\n}\r\n\r\n.layout-card:hover {\r\n  border-color: var(--accent-primary);\r\n  box-shadow: 0 4px 12px var(--shadow-color);\r\n}\r\n\r\n.layout-card.active {\r\n  border-color: var(--accent-primary);\r\n  background: var(--bg-tertiary);\r\n  box-shadow: 0 4px 12px var(--shadow-color);\r\n}\r\n\r\n.layout-preview, .mc-preview {\r\n  width: 100%;\r\n  height: 100px;\r\n  background: var(--bg-primary);\r\n  border: 1px solid var(--border-color);\r\n  border-radius: 6px;\r\n  display: flex;\r\n  overflow: hidden;\r\n}\r\n\r\n.sidebar-preview {\r\n  gap: 4px;\r\n  padding: 4px;\r\n}\r\n\r\n.preview-sidebar {\r\n  width: 20%;\r\n  background: var(--bg-tertiary);\r\n  border-radius: 2px;\r\n}\r\n\r\n.preview-sidebar.right {\r\n  order: 3;\r\n}\r\n\r\n.preview-content {\r\n  flex: 1;\r\n  background: var(--bg-secondary);\r\n  border-radius: 2px;\r\n  order: 2;\r\n}\r\n\r\n.header-preview {\r\n  flex-direction: column;\r\n  gap: 4px;\r\n  padding: 4px;\r\n}\r\n\r\n.preview-header {\r\n  width: 100%;\r\n  height: 25%;\r\n  background: var(--bg-tertiary);\r\n  border-radius: 2px;\r\n}\r\n\r\n.layout-label {\r\n  font-size: 0.95rem;\r\n  font-weight: 600;\r\n  color: var(--text-primary);\r\n}\r\n\r\n.layout-preference {\r\n  margin-top: 20px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 12px;\r\n}\r\n\r\n.layout-preference-label {\r\n  margin: 0;\r\n  font-size: 0.95rem;\r\n  color: var(--text-secondary);\r\n}\r\n\r\n.flux-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));\r\n  gap: 16px;\r\n}\r\n\r\n.flux-preview {\r\n  width: 100%;\r\n  height: 100px;\r\n  background: var(--bg-primary);\r\n  border: 1px solid var(--border-color);\r\n  border-radius: 6px;\r\n  display: grid;\r\n  gap: 6px;\r\n  padding: 8px;\r\n}\r\n\r\n.flux-preview.grid-preview {\r\n  grid-template-columns: repeat(3, 1fr);\r\n  grid-auto-rows: 1fr;\r\n}\r\n\r\n.flux-preview.list-preview {\r\n  grid-template-columns: 1fr;\r\n  grid-auto-rows: 1fr;\r\n}\r\n\r\n.flux-tile,\r\n.flux-row {\r\n  background: var(--bg-secondary);\r\n  border-radius: 4px;\r\n  color:var(--text-primary);\r\n  display: flex;\r\n}\r\n\r\n.flux-row {\r\n  position: relative;\r\n}\r\n\r\n.flux-row div {\r\n  position: absolute;\r\n  bottom:0;\r\n  right:0;\r\n  width:95%;\r\n  height: 60%;\r\n  border-left: 1px solid var(--accent-primary);\r\n  float:right;\r\n  vertical-align: baseline;\r\n}\r\n\r\n/* Comment display preview */\r\n.comment-preview-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));\r\n  gap: 16px;\r\n}\r\n\r\n.comment-display-preview-section .layout-card {\r\n  align-items: flex-start;\r\n  text-align: left;\r\n}\r\n\r\n.comment-display-preview-section .layout-label {\r\n  margin-top: 4px;\r\n}\r\n\r\n.comment-display-preview-section .option-desc, .settings-section .option-desc {\r\n  font-size: 0.85rem;\r\n  color: var(--text-secondary);\r\n  line-height: 1.35;\r\n}\r\n\r\n.flux-preview.preview-small {\r\n  height: 64px;\r\n  padding: 6px;\r\n  gap: 4px;\r\n}\r\n\r\n/* Comment display previews */\r\n\r\n.comment-preview {\r\n  width: 100%;\r\n  min-height: 120px;\r\n  background: var(--bg-primary);\r\n  border: 1px solid var(--border-color);\r\n  border-radius: 8px;\r\n  padding: 10px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 8px;\r\n}\r\n\r\n.preview-card {\r\n  background: var(--bg-secondary);\r\n  border: 1px solid var(--border-color);\r\n  border-radius: 8px;\r\n  padding: 8px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 6px;\r\n}\r\n\r\n.preview-card-header {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n}\r\n\r\n.preview-avatar {\r\n  width: 16px;\r\n  height: 16px;\r\n  border-radius: 50%;\r\n  background: var(--bg-tertiary);\r\n}\r\n\r\n.preview-avatar.small {\r\n  width: 12px;\r\n  height: 12px;\r\n}\r\n\r\n.preview-card-body {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 4px;\r\n}\r\n\r\n.preview-line {\r\n  height: 6px;\r\n  border-radius: 4px;\r\n  background: var(--text-tertiary);\r\n}\r\n\r\n.preview-line.short {\r\n  width: 60%;\r\n}\r\n\r\n.preview-line.tiny {\r\n  width: 30%;\r\n  height: 4px;\r\n}\r\n\r\n.preview-card-actions {\r\n  display: flex;\r\n  gap: 6px;\r\n}\r\n\r\n.preview-card-actions span {\r\n  width: 14px;\r\n  height: 5px;\r\n  border-radius: 999px;\r\n  background: var(--bg-tertiary);\r\n}\r\n\r\n.preview-thread {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 6px;\r\n}\r\n\r\n.preview-comment.level-1 {\r\n  margin-left: 6px;\r\n}\r\n\r\n.preview-comment.level-2 {\r\n  margin-left: 16px;\r\n}\r\n\r\n.preview-inline-thread {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 6px;\r\n  padding-left: 4px;\r\n  border-left: 1px solid var(--accent-primary);\r\n  border-radius: 6px;\r\n  vertical-align: baseline;\r\n  justify-content: flex-end;\r\n  height:40px;\r\n}\r\n\r\n.preview-inline-row {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n}\r\n\r\n.preview-inline-row.nested {\r\n  padding-left: 12px;\r\n  border-left: 1px solid var(--accent-primary);\r\n  border-radius: 6px;\r\n  height:16px;\r\n}\r\n\r\n.preview-dot {\r\n  width: 8px;\r\n  height: 8px;\r\n  border-radius: 50%;\r\n  background: var(--bg-tertiary);\r\n}\r\n\r\n.preview-pill {\r\n  width: 12px;\r\n  height: 4px;\r\n  border-radius: 999px;\r\n  background: var(--bg-tertiary);\r\n}\r\n\r\n.comment-preview-header {\r\n  display: flex;\r\n  gap: 8px;\r\n  align-items: center;\r\n}\r\n\r\n.comment-preview-avatar {\r\n  width: 22px;\r\n  height: 22px;\r\n  border-radius: 50%;\r\n  background: var(--bg-tertiary);\r\n}\r\n\r\n.comment-preview-lines {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 4px;\r\n  flex: 1;\r\n}\r\n\r\n.comment-preview-line {\r\n  height: 6px;\r\n  border-radius: 4px;\r\n  background: var(--bg-secondary);\r\n}\r\n\r\n.comment-preview-line.short {\r\n  width: 60%;\r\n}\r\n\r\n.comment-preview-body {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 4px;\r\n}\r\n\r\n.comment-preview-actions {\r\n  display: flex;\r\n  gap: 8px;\r\n}\r\n\r\n.comment-preview-actions span {\r\n  width: 16px;\r\n  height: 6px;\r\n  border-radius: 999px;\r\n  background: var(--bg-tertiary);\r\n}\r\n\r\n.comment-preview-row {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n}\r\n\r\n\r\n/* Theme Grid */\r\n.theme-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\r\n  gap: 16px;\r\n}\r\n\r\n.theme-card {\r\n  background: var(--bg-secondary);\r\n  border: 2px solid var(--border-color);\r\n  border-radius: 12px;\r\n  padding: 16px;\r\n  cursor: pointer;\r\n  transition: all 0.2s ease;\r\n  text-align: left;\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.theme-card:hover {\r\n  border-color: var(--accent-primary);\r\n  box-shadow: 0 4px 12px var(--shadow-color);\r\n}\r\n\r\n.theme-card.active {\r\n  border-color: var(--accent-primary);\r\n  background: var(--bg-tertiary);\r\n  box-shadow: 0 4px 12px var(--shadow-color);\r\n}\r\n\r\n.theme-content {\r\n  display: flex;\r\n  gap: 12px;\r\n  align-items: center;\r\n}\r\n\r\n.theme-text {\r\n  flex: 1;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 6px;\r\n}\r\n\r\n.theme-content .color-preview {\r\n  width: 50px;\r\n  height: 50px;\r\n  border-radius: 50%;\r\n  border: 1px solid var(--border-color);\r\n  transition: all 0.2s ease;\r\n  flex-shrink: 0;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  position: relative;\r\n}\r\n\r\n.theme-content .checkmark {\r\n  font-size: 1.1rem;\r\n  font-weight: bold;\r\n  color: var(--accent-primary);\r\n  text-shadow: 0 0 8px rgba(0, 0, 0, 0.3);\r\n}\r\n\r\n.theme-card-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  margin-bottom: 8px;\r\n}\r\n\r\n.theme-label {\r\n  font-size: 1.1rem;\r\n  font-weight: 600;\r\n  color: var(--text-primary);\r\n}\r\n\r\n.theme-description {\r\n  margin: 0;\r\n  font-size: 0.9rem;\r\n  color: var(--text-secondary);\r\n}\r\n\r\n.active-indicator {\r\n  color: var(--accent-primary);\r\n  font-size: 1.2rem;\r\n  font-weight: bold;\r\n}\r\n\r\n/* Accent Color Grid */\r\n.accent-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));\r\n  gap: 16px;\r\n}\r\n\r\n.accent-card {\r\n  background: var(--bg-secondary);\r\n  border: 2px solid var(--border-color);\r\n  border-radius: 12px;\r\n  padding: 16px;\r\n  cursor: pointer;\r\n  transition: all 0.2s ease;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  gap: 12px;\r\n  position: relative;\r\n}\r\n\r\n.accent-card:hover {\r\n  border-color: var(--accent-primary);\r\n  box-shadow: 0 4px 12px var(--shadow-color);\r\n}\r\n\r\n.accent-card.active {\r\n  border-color: var(--accent-primary);\r\n  background: var(--bg-tertiary);\r\n  box-shadow: 0 4px 12px var(--shadow-color);\r\n}\r\n\r\n.color-preview {\r\n  width: 50px;\r\n  height: 50px;\r\n  border-radius: 50%;\r\n  border: 3px solid var(--border-color);\r\n}\r\n\r\n.accent-label {\r\n  font-size: 0.95rem;\r\n  font-weight: 600;\r\n  color: var(--text-primary);\r\n}\r\n\r\n.accent-card .active-indicator {\r\n  position: absolute;\r\n  top: 8px;\r\n  right: 8px;\r\n}\r\n\r\ninput[type=\"range\"] {\r\n  width: 100%;\r\n}\r\n\r\n.reward-currency-setting {\r\n  margin-top: 12px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 12px;\r\n}\r\n\r\n.reward-currency-label {\r\n  font-size: 0.95rem; \r\n}\r\n\r\n.currency-toggle {\r\n  position: relative;\r\n  display: flex;\r\n  align-items: center;\r\n  width: 160px;\r\n  padding: 4px;\r\n  border-radius: 999px;\r\n  border: 1px solid var(--input-border);\r\n  background: var(--bg-secondary);\r\n}\r\n\r\n.currency-toggle .currency-option {\r\n  flex: 1;\r\n  text-align: center;\r\n  margin-top: -2px;\r\n  padding:4px;\r\n  font-size: 0.85rem;\r\n  font-weight: 600;\r\n  color: var(--text-secondary);\r\n  z-index: 1;\r\n}\r\n\r\n.currency-toggle .currency-option.active {\r\n  color: var(--accent-primary);\r\n}\r\n\r\n.currency-toggle .currency-slider {\r\n  position: absolute;\r\n  top: 4px;\r\n  bottom: 4px;\r\n  left: 4px;\r\n  width: calc(50% - 4px);\r\n  background: var(--bg-primary);\r\n  border-radius: 999px;\r\n  box-shadow: 0 2px 8px var(--shadow-color);\r\n  transition: transform 0.2s ease;\r\n}\r\n\r\n.currency-toggle.right .currency-slider {\r\n  transform: translateX(100%);\r\n}\r\n\r\n/* Preview Info */\r\n.preview-info {\r\n  background: var(--bg-tertiary);\r\n  border: 1px solid var(--border-color);\r\n  border-radius: 12px;\r\n  padding: 16px;\r\n  display: flex;\r\n  gap: 16px;\r\n  align-items: flex-start;\r\n}\r\n\r\n.preview-icon {\r\n  font-size: 1.5rem;\r\n}\r\n\r\n.preview-text {\r\n  flex: 1;\r\n}\r\n\r\n.preview-text strong {\r\n  display: block;\r\n  margin-bottom: 4px;\r\n  color: var(--text-primary);\r\n  font-size: 1rem;\r\n}\r\n\r\n.preview-text p, .coming-soon {\r\n  margin: 0;\r\n  color: var(--text-secondary);\r\n  font-size: 0.9rem;\r\n}\r\n.disabled {\r\n  pointer-events: none;\r\n  opacity: 0.6;\r\n  border: 2px solid var(--border-color);\r\n}\r\n.disabled:hover {\r\n  pointer-events: none;\r\n  opacity: 0.6;\r\n  border: 2px solid var(--border-color);\r\n}\r\n\r\n/* Current Selection */\r\n.current-selection {\r\n  background: var(--bg-secondary);\r\n  border: 1px solid var(--border-color);\r\n  border-radius: 12px;\r\n  padding: 20px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 12px;\r\n}\r\n\r\n.selection-item {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n}\r\n\r\n.selection-label {\r\n  color: var(--text-secondary);\r\n  font-size: 0.95rem;\r\n}\r\n\r\n.selection-value {\r\n  color: var(--text-primary);\r\n  font-weight: 600;\r\n  font-size: 1rem;\r\n}\r\n\r\n/* Footer */\r\n.settings-footer {\r\n  position: fixed;\r\n  bottom: 0;\r\n  left: 0;\r\n  right: 0;\r\n  background: var(--bg-secondary);\r\n  border-top: 2px solid var(--border-color);\r\n  padding: 16px 20px;\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  box-shadow: 0 -4px 12px var(--shadow-color);\r\n  z-index: 100;\r\n}\r\n\r\n.unsaved-indicator {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  color: var(--accent-primary);\r\n  font-weight: 500;\r\n}\r\n\r\n.unsaved-dot {\r\n  animation: pulse 2s infinite;\r\n}\r\n\r\n@keyframes pulse {\r\n  0%, 100% { opacity: 1; }\r\n  50% { opacity: 0.5; }\r\n}\r\n\r\n.footer-buttons {\r\n  display: flex;\r\n  gap: 12px;\r\n}\r\n\r\n.reset-btn {\r\n  padding: 12px 24px;\r\n  background: var(--bg-tertiary);\r\n  color: var(--text-primary);\r\n  border: 1px solid var(--border-color);\r\n  border-radius: 8px;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  transition: all 0.2s ease;\r\n}\r\n\r\n.reset-btn:hover {\r\n  background: var(--bg-primary);\r\n  border-color: var(--error-color);\r\n  color: var(--error-color);\r\n}\r\n\r\n.save-btn {\r\n  padding: 12px 32px;\r\n  background: var(--accent-primary);\r\n  color: white;\r\n  border: none;\r\n  border-radius: 8px;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  transition: all 0.2s ease;\r\n  font-size: 1rem;\r\n}\r\n\r\n.save-btn:hover:not(:disabled) {\r\n  background: var(--accent-hover);\r\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);\r\n}\r\n\r\n.save-btn:disabled {\r\n  background: var(--bg-tertiary);\r\n  color: var(--text-tertiary);\r\n  cursor: not-allowed;\r\n  opacity: 0.6;\r\n}\r\n\r\n.save-btn.has-changes {\r\n  animation: glow 2s infinite;\r\n}\r\n\r\n@keyframes glow {\r\n  0%, 100% { box-shadow: 0 0 8px var(--accent-primary); }\r\n  50% { box-shadow: 0 0 16px var(--accent-primary); }\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .settings-container {\r\n    padding: 16px;\r\n  }\r\n\r\n  .signature-textarea {\r\n    font-size: 0.92rem;\r\n    padding: 10px 12px;\r\n  }\r\n\r\n  .signature-live-preview-header {\r\n    padding: 9px 10px;\r\n    font-size: 0.82rem;\r\n  }\r\n\r\n  .signature-preview-post-card {\r\n    padding: 12px;\r\n  }\r\n\r\n  .signature-preview-avatar {\r\n    width: 36px;\r\n    height: 36px;\r\n  }\r\n\r\n  .signature-live-preview-content,\r\n  .signature-live-preview-empty {\r\n    padding: 0;\r\n  }\r\n\r\n  .signature-live-preview-empty {\r\n    padding-top: 2px;\r\n  }\r\n\r\n  .theme-grid {\r\n    grid-template-columns: 1fr;\r\n  }\r\n\r\n  .accent-grid {\r\n    grid-template-columns: repeat(3, 1fr);\r\n  }\r\n\r\n  .settings-footer {\r\n    flex-direction: column;\r\n    gap: 12px;\r\n  }\r\n\r\n  .footer-buttons {\r\n    width: 100%;\r\n  }\r\n\r\n  .reset-btn,\r\n  .save-btn {\r\n    flex: 1;\r\n  }\r\n}\r\n\r\n/* Notification opt-in styles removed */\r\n\r\n/* Data Sync Section */\r\n.sync-info {\r\n  background: var(--bg-tertiary);\r\n  border: 1px solid var(--border-color);\r\n  border-radius: 8px;\r\n  padding: 16px;\r\n  margin-bottom: 16px;\r\n}\r\n\r\n.sync-info p {\r\n  margin: 0 0 8px 0;\r\n  color: var(--text-primary);\r\n  font-weight: 500;\r\n}\r\n\r\n.sync-info ul {\r\n  margin: 0;\r\n  padding-left: 20px;\r\n  color: var(--text-secondary);\r\n}\r\n\r\n.sync-info li {\r\n  margin: 4px 0;\r\n}\r\n\r\n.sync-btn {\r\n  padding: 14px 28px;\r\n  background: var(--accent-primary);\r\n  color: white;\r\n  border: none;\r\n  border-radius: 8px;\r\n  font-weight: 600;\r\n  font-size: 1rem;\r\n  cursor: pointer;\r\n  transition: all 0.2s ease;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n  width: fit-content;\r\n}\r\n\r\n.sync-btn:hover:not(:disabled) {\r\n  background: var(--accent-hover);\r\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);\r\n  transform: translateY(-2px);\r\n}\r\n\r\n.sync-btn:disabled {\r\n  background: var(--bg-tertiary);\r\n  color: var(--text-tertiary);\r\n  cursor: not-allowed;\r\n  opacity: 0.6;\r\n}\r\n\r\n.sync-icon {\r\n  font-size: 1.2rem;\r\n}\r\n\r\n.sync-spinner {\r\n  font-size: 1.2rem;\r\n  animation: spin 1s linear infinite;\r\n}\r\n\r\n@keyframes spin {\r\n  from { transform: rotate(0deg); }\r\n  to { transform: rotate(360deg); }\r\n}\r\n\r\n.sync-status {\r\n  margin-top: 12px;\r\n  padding: 12px 16px;\r\n  border-radius: 8px;\r\n  font-size: 0.95rem;\r\n  font-weight: 500;\r\n}\r\n\r\n.sync-status.success {\r\n  background: rgba(76, 175, 80, 0.1);\r\n  color: #4caf50;\r\n  border: 1px solid rgba(76, 175, 80, 0.3);\r\n}\r\n\r\n.sync-status.warning {\r\n  background: rgba(255, 152, 0, 0.1);\r\n  color: #ff9800;\r\n  border: 1px solid rgba(255, 152, 0, 0.3);\r\n}\r\n\r\n.sync-status.error {\r\n  background: rgba(244, 67, 54, 0.1);\r\n  color: #f44336;\r\n  border: 1px solid rgba(244, 67, 54, 0.3);\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
